import { type CountryCode, validatePhoneNumberLength } from 'libphonenumber-js'

export function getPhoneValidationError(
  value: string,
  countryCode?: CountryCode
): string | null {
  const result = validatePhoneNumberLength(value, countryCode)

  if (!result) return null

  switch (result) {
    case 'NOT_A_NUMBER':
    case 'TOO_SHORT':
      return 'The number is shorter than all valid numbers for this region.'
    case 'INVALID_COUNTRY':
      return 'The number has an invalid country calling code.'
    case 'TOO_LONG':
      return 'The number is longer than all valid numbers for this region.'
    case 'INVALID_LENGTH':
      return 'The number does not match the length for valid numbers for this region.'
    default:
      return 'Please enter a valid phone number.'
  }
}
